import { isErrorShaped } from 'utils/isErrorShaped';

export const isUserGestureError = (error: unknown): boolean =>
  isErrorShaped(error) &&
  (error.name === 'NotAllowedError' || error.message.includes('user gesture'));
